import { computed, unref, type Ref } from "vue";
import { useQuery } from "@tanstack/vue-query";
import CrmIntegration from "@/services/integrations/crm-integration";

export function useCrmConnections(organizationId: Ref<string | null> | string | null) {
  const queryKey = computed(() => {
    const orgId = unref(organizationId);
    if (!orgId) return ["crmConnections", "disabled"];
    return ["crmConnections", orgId];
  });

  const enabled = computed(() => {
    const orgId = unref(organizationId);
    return !!orgId;
  });

  return useQuery({
    queryKey,
    queryFn: async () => {
      const result = await CrmIntegration.getConnections();
      if (result.data.status) {
        return result.data.data;
      }
      throw new Error(result.data.msg || "Failed to load CRM connections");
    },
    enabled,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });
}
